import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-bold tracking-tight cursor-pointer">
              楼凤论坛
            </Link>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
              楼凤论坛是汇聚用户真实体验、资讯分享与社区交流的综合性论坛平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">首页</Link>
              <Link to="/category/latest-news" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">最新资讯</Link>
              <Link to="/category/user-sharing" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">用户分享</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/experience-exchange" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">经验交流</Link>
              <Link to="/category/q-and-a" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">求助问答</Link>
              <Link to="/category/announcements" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">社区公告</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">联系我们</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-400">邮箱：contact@loufengbbs.com</span>
              <span className="text-sm text-foreground-400">电话：400-888-8888</span>
              <span className="text-sm text-foreground-400">微信：loufengbbs</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; 2024 楼凤论坛 版权所有
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-sm text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link>
            <span className="text-sm text-foreground-500 cursor-pointer hover:text-background-50 transition-colors">隐私政策</span>
            <span className="text-sm text-foreground-500 cursor-pointer hover:text-background-50 transition-colors">用户协议</span>
            <Link to="/about" className="text-sm text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}